import { BaseApi } from './base.api.js';

export class KpiApi extends BaseApi {
    constructor(client) {
        super(client, '/kpi');
    }

    async getStats() {
        const response = await this.client.get(`${this.basePath}/stats`);
        return response.data;
    }
}
